<p-toast />

<app-report-mixture-card-dialog
  [visible]="mixtureDialogOpen"
  (visibleChange)="onMixtureDialogVisibleChange($event)"
  [reportId]="fillReportId"
  [companyId]="companyContext.currentCompanyId"
  [mixture]="mixtureDialogMixture"
  (saved)="onMixtureDialogSaved()"
/>

<div class="report-fill-page">
  <p-breadcrumb class="report-fill-breadcrumb" [model]="breadcrumbItems" />

  <div class="report-fill-title-row">
    @if (isLoading) {
      <p-skeleton width="min(28rem, 75%)" height="1.75rem" styleClass="report-fill-title-skeleton" />
    } @else if (calculation) {
      <h1 class="report-fill-heading">{{ calculation.title }}</h1>
    } @else if (loadErrorKey) {
      <p class="report-fill-error">{{ loadErrorKey | translate }}</p>
    }
  </div>

  @if (!loadErrorKey) {
    <div class="report-fill-section-head">
      <h2 class="report-fill-heading report-fill-section-label">
        {{ 'reports.fill.sectionCharacteristic' | translate }}
      </h2>
      <p-button
        type="button"
        [label]="'reports.fill.addCard' | translate"
        icon="pi pi-plus"
        styleClass="report-fill-add-card-btn"
        [disabled]="isLoading || !calculation || !companyContext.currentCompanyId"
        (onClick)="openMixtureDialogCreate()"
      />
    </div>

    @if (isLoading) {
      <div class="report-fill-mixtures flex flex-col gap-4">
        @for (i of [1, 2]; track i) {
          <div
            class="border border-gray-200 bg-white rounded-xl shadow-sm p-4 flex flex-col gap-4 dark:border-gray-700 dark:bg-slate-900/80"
          >
            <div class="flex items-center justify-between gap-3">
              <p-skeleton width="min(18rem, 55%)" height="1.25rem" />
              <div class="flex items-center gap-2">
                <p-skeleton width="4.5rem" height="2rem" />
                <p-skeleton width="4.5rem" height="2rem" />
              </div>
            </div>
            <p-skeleton width="100%" height="2.5rem" />
            <p-skeleton width="100%" height="16rem" />
            <div class="flex items-center gap-2">
              <p-skeleton width="6rem" height="1rem" />
              <p-skeleton width="5rem" height="1rem" />
              <p-skeleton width="1rem" height="1rem" />
              <p-skeleton width="6rem" height="1rem" />
              <p-skeleton width="5rem" height="1rem" />
            </div>
          </div>
        }
      </div>

      <app-report-calculation-summary
        class="report-fill-summary"
        [loading]="true"
        [totalEmission]="0"
        [reportId]="fillReportId"
      />
    } @else if (calculation) {
      @if (calculation.mixtures.length === 0) {
        <p class="text-gray-600 text-sm m-0 dark:text-gray-400">{{ 'reports.fill.emptyMixtures' | translate }}</p>
      } @else {
        <div class="report-fill-mixtures flex flex-col gap-4">
          @for (m of calculation.mixtures; track m.id) {
            <app-report-mixture-calculation-card
              [mixture]="m"
              [reportId]="fillReportId"
              [companyId]="companyContext.currentCompanyId"
              (editMixture)="openMixtureDialogEdit($event)"
              (mixtureDeleted)="onMixtureDeleted()"
              (mixtureChanged)="onMixtureChanged()"
            />
          }
        </div>
      }

      <app-report-calculation-summary
        class="report-fill-summary"
        [substances]="calculation.substances"
        [totalEmission]="calculation.totalEmission"
        [reportId]="fillReportId"
      />
    }
  }
</div>
